import { privateInstance } from "../configs";

export const expirationApi = {
  async getExpirations() {
    const res = await privateInstance.get(`/inventory/api/expiration/`);
    return res.data;
  }
};
